import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import BaseLayout from 'bento-ordering/base/layouts/BaseLayout';
import { isMobileMedia } from 'bento-ordering/utils/media';
import { ORDER_SETTINGS_ID } from 'constants/layout';

const LAYOUT_PADDING = {
  pl: 0,
  pr: 0,
  pb: 3
};

const OrderSettingsLayout = ({ children, heroImage, isFetching }) => {
  return (
    <BaseLayout
      heroImage={heroImage}
      isFetching={isFetching}
      hideNav
      hideHeroOnMobile
      hideBrandFooterOnMobile
      hideMobileStickyCtaFooter
      isModal
      layoutPadding={LAYOUT_PADDING}
      id={ORDER_SETTINGS_ID}
      shouldUseMenuStyle={!isMobileMedia()}
    >
      {children}
    </BaseLayout>
  );
};

OrderSettingsLayout.propTypes = {
  children: PropTypes.object,
  heroImage: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
    url: PropTypes.string,
    alt_text: PropTypes.string
  }),
  isFetching: PropTypes.bool
};

const mapStateToProps = state => ({
  isFetching: state.menu.isFetching,
  heroImage: get(state.menu, 'images[0]', {})
});

export default connect(mapStateToProps)(OrderSettingsLayout);
